import { Stack, Text, useTheme, Button } from '@ltvco/refresh-lib/theme';
import { useChatContext } from '@ltvco/refresh-lib/v2';
import { AutoAwesomeOutlined } from '@mui/icons-material';

type RetrySearchInstructionProps = {
  onClearImage: () => void;
};
export const RetrySearchInstruction = ({
  onClearImage,
}: RetrySearchInstructionProps) => {
  const theme = useTheme();
  const { handleNewChat } = useChatContext();

  const handleButtonClick = () => {
    handleNewChat();
    onClearImage();
  };

  return (
    <Stack
      width="100%"
      maxWidth="760px"
      spacing={2}
      direction="row"
      p={2}
      sx={{ backgroundColor: 'background.default', borderRadius: 2 }}
    >
      <AutoAwesomeOutlined sx={{ color: theme.palette.primary.main }} />
      <Stack direction="column" alignItems="start" gap={1}>
        <Text variant="body1" mb={1}>
          Anything else we can help you with?
        </Text>
        <Button
          variant="outlined"
          onClick={handleButtonClick}
          sx={{ width: 'fit-content' }}
        >
          Try another Search
        </Button>
      </Stack>
    </Stack>
  );
};
